export { HeaderNews } from './HeaderNews';
export { BodyNews } from './BodyNews';
